import { RefreshCw, Trophy } from "lucide-react";
import { useEffect, useState } from "react";
import { fetchLeaderboard } from "../utils/tcg";

const rankClass = (index) => (index === 0 ? "rank-first" : index === 1 ? "rank-second" : index === 2 ? "rank-third" : "");

/* War council rankings — signed-in commanders ordered by arena wins,
   flawless sweeps breaking ties. */
export function TcgLeaderboard() {
  const [rows, setRows] = useState(null);

  const load = () => {
    fetchLeaderboard()
      .then(setRows)
      .catch(() => setRows([]));
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className="leaderboard" data-testid="tcg-leaderboard">
      <div className="leaderboard-head">
        <h3>
          <Trophy size={16} /> WAR COUNCIL RANKINGS
        </h3>
        <button type="button" onClick={load} data-testid="leaderboard-refresh" aria-label="Refresh rankings">
          <RefreshCw size={14} /> REFRESH
        </button>
      </div>

      {rows === null ? (
        <p className="leaderboard-empty">PULLING RANKINGS FROM THE NET…</p>
      ) : rows.length === 0 ? (
        <p className="leaderboard-empty" data-testid="leaderboard-empty">
          NO COMMANDERS RANKED YET — SIGN IN AND WIN A BATTLE TO ETCH YOUR NAME.
        </p>
      ) : (
        <div className="leaderboard-table" data-testid="leaderboard-table">
          <div className="leaderboard-row is-head">
            <span>RANK</span>
            <span>COMMANDER</span>
            <span>W — L — D</span>
            <span>FLAWLESS</span>
            <span>BATTLES</span>
          </div>
          {rows.map((row, index) => (
            <div key={`${row.name}-${index}`} className={`leaderboard-row ${rankClass(index)}`} data-testid={`leaderboard-row-${index}`}>
              <span className="rank-no">{String(index + 1).padStart(2, "0")}</span>
              <span className="rank-name">{row.name}</span>
              <span>{row.wins} — {row.losses} — {row.draws}</span>
              <span className="rank-flawless">{row.flawless || 0}</span>
              <span>{row.battles}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
